import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        if (!value)
            return value;

        // First remove any non-digit characters
        value = value.replace(/\D/g, '');

        // Then format in standard US pattern: 3-3-4
        let parts = [value.substr(-4)];
        const len = value.length;
        if (len > 4) {
            let partLen = Math.min(len - 4, 3);
            parts.unshift(value.substr(-4 - partLen, 3));
            if (len > 7) {
                partLen = len - 7;
                parts.unshift(value.substr(0, partLen));
            }
        }
        return parts.join("-");
    }

}
